import React, { useEffect, useState } from 'react';
import './login.css';
import { Navigate } from 'react-router-dom';
import {api} from '../../services/api';
import FundoMulher from '../../images/fundoMulher.png';
import Logo from '../../images/logoNovo.png'
import {vhostV1, vhostV2} from '../funcoes';
import { use } from 'react';

//import { AuthContext } from '../context/auth';

function Login(){

  const inputs = document.querySelectorAll("input, button");

// Adicione um manipulador de eventos para o evento "keydown" em cada entrada ou botão
inputs.forEach(input => {
  input.addEventListener("keydown", e => {
    // Se a tecla pressionada for Enter
    if (e.key === "Enter") {
      e.preventDefault(); // evita que a tecla "Enter" envie um formulário, se aplicável

      // Verifica se o elemento atual é um botão
      if (input.tagName.toLowerCase() === 'button') {
        input.click(); // Aciona o botão
      } else {
        // Obtenha o índice do elemento atual
        const currentIndex = Array.from(inputs).indexOf(e.target);
        
        // Mova o foco para o próximo elemento de entrada ou botão
        const nextIndex = currentIndex + 1;
        if (nextIndex < inputs.length) {
          inputs[nextIndex].focus();
        }
      }
    }
  });
});

 function hojeFormatado() {
  return new Date().toISOString().substring(0, 10);
}
   
    
    const [email,setEmail] = useState('');
    const [senha,setSenha] = useState('');
    const [iloja,setIloja] = useState('');
    const [sucesso,setSucesso] = useState('');
    const [loading,setLoading] = useState(false); 
    const [sucesso1,setSucesso1] = useState('');
    const [sucesso2,setSucesso2] = useState('');
    //const {setLogado} = React.useContext(AuthContext)



    function LoginUsuario(e){
         e.preventDefault()
         setLoading(true);      
        

         api.post(vhostV1('webcash/login'), {
          loja: iloja,
          user: email.toUpperCase(),
          pwd: senha
        })
        .then(function (response) {
          console.log(response);
          if(response.data.result === 0){
            setSucesso1('N');
            setLoading(false);
            return;
          }
          
          localStorage.setItem("loja",iloja);  
          localStorage.setItem("usuario",email);
          localStorage.setItem("colaborador",response.data.data.usuario);  
          localStorage.setItem("token",response.data.data.authorization);
          localStorage.setItem("dataInicial", hojeFormatado() + 'T10:10:00.000Z')
          localStorage.setItem("dataFinal", hojeFormatado() + 'T10:10:00.000Z') 
          localStorage.setItem("usuarioMpmId", response.data.data.usuarioMpmId);
          localStorage.setItem("empresaMpmId", response.data.data.empresaMpmId);
          localStorage.setItem("tokenMpm", response.data.data.tokenMpm);
          
          setSucesso1('S');
          // setLoading(false);
        })
        .catch(function (error) {
          console.log(error);
          
          setSucesso1('N');
          setLoading(false);
        });
        
      
    }

   
    

    function LoginUsuarioApi(e){
      e.preventDefault()
      setLoading(true);      
     

      api.post(vhostV2('webcash/login'), {
       loja: iloja,
       user: email.toUpperCase(),
       pwd: senha
     })
     .then(function (response) {
       console.log(response);
        if(response.data.result === 0){
          setSucesso2('N');
          setLoading(false);
          return;
        }
       
       localStorage.setItem("loja2",iloja);  
       localStorage.setItem("usuario2",email);
       localStorage.setItem("colaborador2",response.data.usuario);  
       localStorage.setItem("token2",response.data.authorization);  
       
       setSucesso2('S');
      //  setLoading(false);
     })
     .catch(function (error) {
       console.log(error);
       
       setSucesso2('N');
       setLoading(false);
     });
     
   
 }

 useEffect(() => {
  if(sucesso1 === 'S' && sucesso2 === 'S'){
    setSucesso('S');
    setLoading(false);
}else if(sucesso1 === 'N' && sucesso2 === 'N'){
  setSucesso('N');
  setLoading(false);
}
 }, [sucesso1,sucesso2, sucesso]);

  function handleClick(e){
    LoginUsuario(e);
    LoginUsuarioApi(e);
    
}

    {const event = new Date();
    
    // Expected output: "Wed Oct 05 2011 16:48:00 GMT+0200 (CEST)"
    // Note: your timezone may vary
    
    
    // Expected output: "2011-10-05T14:48:00.000Z"
    }

    
    return <div className="vh-100 vw-100 overflow-hidden d-flex flex-column">
    <div className='row h-100 w-100 m-0'>
      <div className="col-sm-6 d-flex justify-content-center align-items-center text-center form-container">
        <form className="form-signin w-75">
          <img src={Logo} alt="" className="mb-4" />
          <h1 className="h3 mb-3 fw-normal">Bem vindo</h1>
          <h6>Acesse sua conta</h6>

          <label className='d-flex justify-start' htmlFor="lojaInput">Loja</label>
          <div className="form-floating mb-3">
            <input type="text"
                   className="form-control" 
                   id="lojaInput" 
                   placeholder="Loja" 
                   onChange={(e) => setIloja(e.target.value)} />
          </div>

          <label className='d-flex justify-start' htmlFor="floatingInput">Usuário</label>
          <div className="form-floating mb-3">  
            <input type="email" 
                   className="form-control" 
                   id="floatingInput" 
                   placeholder="Usuário" 
                   onChange={(e) => setEmail(e.target.value)} />
          </div>

          <label className='d-flex justify-start' htmlFor="floatingPassword">Senha</label>
          <div className="form-floating">
            <input type="password" 
                   className="form-control" 
                   id="floatingPassword" 
                   placeholder="Senha"
                   onChange={(e) => setSenha(e.target.value)} />
          </div>

          <button className="btn btn-primary btn-lg w-100 mt-3" onClick={handleClick}>
            {loading ? <div className="spinner-border text-light" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div> : <span className="ms-2">Acessar</span>}
          </button>

          {sucesso === 'N' && <div className="alert alert-danger mt-3" role="alert">Usuário ou senha incorreta!</div>}
          {sucesso === 'S' && <Navigate to="/app/home" />}

          <p className="mt-5 mb-3 text-muted">&copy; Desenvolvido por SRI automação</p>
        </form>
      </div>

      <div className='col-sm-6 px-0 d-none d-sm-block'>
        <img className='w-100 h-100' style={{ objectFit: 'cover', objectPosition: 'left' }} src={FundoMulher} alt="WebLite" />
      </div>
    </div>
  </div>
  }

export default Login;